import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    BrowserModule,
    HAMMER_GESTURE_CONFIG,
    HammerGestureConfig
} from '@angular/platform-browser';
import { TransferState, makeStateKey } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Angulartics2Module } from 'angulartics2';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FormsModule } from '@angular/forms';
import {
    EcapCoreModule,
    InterceptorModule,
    AppProvider,
    EcapCorporateIdentityService,
    TransferHttpCacheModule,
    ClientMonitoringService,
    ClientMonitoringErrorHandler, StorageDataService
} from '@ecap3/core';
import { FuseMainModule, PlatformChatService } from '@ecap3/template-atlas';
import { FuseNavigationModule } from '../fuse/navigation/navigation.module';
import { PlatformBreadcrumbSharedModule } from '@ecap3/app-platform-breadcrumb-shared-module';

import { routes } from './routes';
import { environment } from '../../environments/environment';
import { UpdateService } from './service/updateSw';
import { TitleService } from './service/title.service';
import { RootComponentsModule } from './root-components.module';
import { RootDefaultComponent } from './root-default/root-default.component';

import { SignalrNotificationModule } from '@ecap3/signalr-notification';
import { MultiTranslateHttpLoader } from '@ecap3/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from '@ecap3/core';
import { TranslateStore } from '@ngx-translate/core';
import { UrlSerializer, DefaultUrlSerializer } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { FuseModule } from '../fuse/fuse.module';

import { NgxPullToRefreshModule } from '../shared/stubs/other-stubs.module';
// import { NgxPullToRefreshModule } from 'ngx-pull-to-refresh';
import { FeatherIconModule } from './feather-icon.module';
import { AvatarModule } from 'ngx-avatars';
import { SharedModule } from '../shared/shared.module';
import { FuseSharedModule } from '@ecap3/template-atlas';
import { GraphQLModule } from '@ecap3/app-platform-graphql';
import { MaterialModule } from '../shared/material.module';
import { SecurityPermissionService } from '../business/arc-config/utils/security-permission.service';
import { SharedService } from '../shared/services/shared.service';
import { AppSharedPipeModule } from '../app-shared-pipe/app-shared-pipe.module';
import { PlatfromCalendarService } from '../business/app-platform-calendar';
import { CustomNotificationService } from './service/custom-notification.service';
import { genericHttpLoaderFactory } from '../shared/providers/delta-uilm-provider';
import * as Hammer from 'hammerjs';
// Removed redundant imports of notification components as they are now in AppNotificationModule
import { DeltaStorageService } from '../shared/services/delta-storage-service';
import { provideNgxMask } from 'ngx-mask';

import { SentryModule } from '../shared/modules/sentry/sentry.module';
// import { CalendarModule, DateAdapter as CalendarDateAdapter } from 'src/app/shared/stubs/calendar-stub.module';
import { CalendarModule, DateAdapter as CalendarDateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { AppNotificationListComponent } from '../business/app-notification/components/app-notification-list/app-notification-list.component';

registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeIt, 'it-IT');
registerLocaleData(localeEn, 'en-EN');


@Injectable()
export class HammerConfig extends HammerGestureConfig {
    overrides = <any>{
        'swipe': { direction: Hammer.DIRECTION_ALL }
    };
}

@NgModule({ declarations: [AppNotificationListComponent],
    // entryComponents: [
        // SLSNToolbarComponent,
        // FuseAboutComponentDynamic,
        // AboutDialog,
        // FuseQuickPanelComponent,
        // NavbarVerticalStyle2Component,
        
        // LeaveOverviewBottomsheetComponent
    // ],
    bootstrap: [RootDefaultComponent], 
    imports: [HttpClientModule,
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        SignalrNotificationModule,
        BrowserModule.withServerTransition({ appId: 'arc' }),
        BrowserAnimationsModule,
        PlatformBreadcrumbSharedModule,
        EcapCoreModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: genericHttpLoaderFactory(['generic-app', 'notification']),
                deps: [HttpClient]
            },
            isolate: false
        }),
        InterceptorModule,
        FuseMainModule,
        TransferHttpCacheModule.forRoot(),
        FormsModule,
        CommonModule,
        NgxPullToRefreshModule,
        FeatherIconModule,
        SharedModule,
        FuseSharedModule,
        GraphQLModule,
        MaterialModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt-md',
                'gt-lg'
            ]
        }),
        RouterModule.forRoot(routes, {
            initialNavigation: environment.initialNavigation
        }),
        ServiceWorkerModule.register('/ngsw-worker.js', {
            enabled: environment.production
        }),
        Angulartics2Module.forRoot({
            pageTracking: {
                excludedRoutes: ['login'],
                clearQueryParams: true,
                clearHash: true
            }
        }),
        FuseNavigationModule,
        AppSharedPipeModule,
        SentryModule,

        CalendarModule.forRoot({
            provide: CalendarDateAdapter,
            useFactory: adapterFactory
        }),
        FuseModule,
        RootComponentsModule], providers: [
        UpdateService,
        TitleService,
        CookieService,
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
        PlatformChatService,
        SecurityPermissionService,
        SharedService,
        PlatfromCalendarService,
        CustomNotificationService,
        {
            provide: StorageDataService,
            useClass: DeltaStorageService
        },
        provideNgxMask(),
        // --- ANGULAR 18 NG0204 INJECTABLE WORKAROUNDS ---
        // View Engine libraries that lost ngcc compilation throw NG0204 in Angular 18.
        // Providing them with useFactory bypasses the missing @Injectable() metadata check.
        { provide: CookieService, useFactory: () => new CookieService(document, null) },
        { provide: TranslateStore, useFactory: () => new TranslateStore() },
        { provide: UrlSerializer, useFactory: () => new DefaultUrlSerializer() },
    ] })
export class RootBrowserModule {
    constructor(
        private appProvider: AppProvider,
        private ecapCorporateIdentityService: EcapCorporateIdentityService,
        private clientMonitoringService: ClientMonitoringService,
        private clientMonitoringErrorHandler: ClientMonitoringErrorHandler
    ) {
        this.clientMonitoringService.init();
        this.appProvider.setCurrentApps(routes);
        const langs = ['en', 'de'];
        const langmatch = /en|de/;

        this.ecapCorporateIdentityService.setTitle('Delta Security');
    }
}
